import React, { useEffect, useState } from "react";
import { useGetFetchNew } from "../../../data/Queries";
import {
  expense_top_paid,
  expense_top_gyms_spend,
  expense_month_trend,
  expense_top_category_spend,
  expense_pending_fd_vendor,
} from "../../../data/ApiEndpoints";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import {
  topGymsColumns,
  topPaidColumns,
  pendingFdVendorColumns,
} from "./ExpenseAnalyticsUtils";
import "./ExpenseAnalyticsLanding.css";

const ExpenseAnalyticsLanding = ({ userInfoData, filters }) => {
  const [isPage, setIsPage] = useState({
    topPaid: 0,
    topGyms: 0,
    pendingFdVendor: 0,
  });

  // const [pageLimit, setPageLimit] = useState({
  //   topPaid: 10,
  //   topGyms: 10,
  //   pendingFdVendor: 10,
  // });

  console.log("filters", filters);

  const [pageLimit, setPageLimit] = useState(5);

  const analyticsFilters = {
    cm_id:
      userInfoData?.account_type === "cluster_manager"
        ? userInfoData?.uid || userInfoData?.user_id
        : filters.requested_by || "",
    gym_id: filters.gym_id || "",
  };

  const [showAllMonths, setShowAllMonths] = useState(false);

  // API calls for analytics data
  const {
    data: topPaidData,
    isLoading: topPaidLoading,
    refetch: refetchTopPaid,
  } = useGetFetchNew({
    token: userInfoData?.token,
    key: "expense_top_paid",
    url: expense_top_paid,
    filters: {
      ...analyticsFilters,
      limit: pageLimit,
      page: isPage.topPaid + 1,
    },
  });

  const {
    data: topGymsData,
    isLoading: topGymsLoading,
    refetch: refetchTopGyms,
  } = useGetFetchNew({
    token: userInfoData?.token,
    key: "expense_top_gyms_spend",
    url: expense_top_gyms_spend,
    filters: {
      ...analyticsFilters,
      limit: pageLimit,
      page: isPage.topGyms + 1,
    },
  });

  const {
    data: monthTrendData,
    isLoading: monthTrendLoading,
    refetch: refetchMonthTrend,
  } = useGetFetchNew({
    token: userInfoData?.token,
    key: "expense_month_trend",
    url: expense_month_trend,
    filters: analyticsFilters,
  });

  const {
    data: categorySpendData,
    isLoading: categorySpendLoading,
    refetch: refetchCategorySpend,
  } = useGetFetchNew({
    token: userInfoData?.token,
    key: "expense_top_category_spend",
    url: expense_top_category_spend,
    filters: {
      ...analyticsFilters,
    },
  });

  const {
    data: pendingFdVendorData,
    isLoading: pendingFdVendorLoading,
    refetch: refetchPendingFdVendor,
  } = useGetFetchNew({
    token: userInfoData?.token,
    key: "expense_pending_fd_vendor",
    url: expense_pending_fd_vendor,
    filters: {
      ...analyticsFilters,
      limit: pageLimit,
      page: isPage.pendingFdVendor + 1,
    },
  });

  console.log("filters", filters);

  useEffect(() => {
    refetchTopPaid();
    refetchTopGyms();
    refetchMonthTrend();
    refetchCategorySpend();
    refetchPendingFdVendor();
  }, [isPage, pageLimit, filters]);

  console.log("isPage", isPage);
  console.log("analyticsFilters", analyticsFilters);

  console.log("pageLimit", pageLimit);

  return (
    <div className="expense-analytics-wrapper">
      {/* KPI Cards Section */}
      <div className="kpi-section">
        <h3 className="card-title" style={{ marginBottom: "20px" }}>
          Key Metrics Overview
        </h3>

        {monthTrendLoading ? (
          <div className="loading-container">Loading metrics...</div>
        ) : (
          <>
            <div className="trend-summary">
              <div className="trend-card trend-card-paid">
                <div className="trend-value">
                  ₹
                  {parseInt(
                    monthTrendData?.summary?.total_paid || 0
                  ).toLocaleString()}
                </div>
                <div className="trend-label">
                  Total Paid ({monthTrendData?.year})
                </div>
              </div>
              <div className="trend-card trend-card-requested">
                <div className="trend-value">
                  ₹
                  {parseInt(
                    monthTrendData?.summary?.total_requested || 0
                  ).toLocaleString()}
                </div>
                <div className="trend-label">
                  Total Requested ({monthTrendData?.year})
                </div>
              </div>
              <div className="trend-card trend-card-category">
                <div className="trend-value">
                  ₹
                  {parseInt(
                    categorySpendData?.summary?.grand_total_spend || 0
                  ).toLocaleString()}
                </div>
                <div className="trend-label">Total Category Spend</div>
              </div>
              <div className="trend-card trend-card-categories">
                <div className="trend-value">
                  {categorySpendData?.summary?.total_categories || 0}
                </div>
                <div className="trend-label">Active Categories</div>
              </div>
              <div className="trend-card trend-card-pending">
                <div className="trend-value">
                  ₹
                  {parseInt(
                    pendingFdVendorData?.summary?.total_pending_amount || 0
                  ).toLocaleString()}
                </div>
                <div className="trend-label">Pending FD Amount</div>
              </div>
              <div className="trend-card trend-card-requesters">
                <div className="trend-value">
                  {pendingFdVendorData?.summary?.total_requesters || 0}
                </div>
                <div className="trend-label">Pending Requesters</div>
              </div>
            </div>
          </>
        )}
      </div>

      {/* Month Trend Section */}
      <div className="analytics-card" style={{ marginBottom: "24px" }}>
        <div className="card-header">
          <h3 className="card-title">
            Monthly Expense Trends ({monthTrendData?.year})
          </h3>
          <div className="trend-actions">
            {/* <button className="view-all-btn">Export Data</button> */}
          </div>
        </div>
        {monthTrendLoading ? (
          <div className="loading-container">Loading trend data...</div>
        ) : (
          <div className="enterprise-trend-container">
            {/* <div className="trend-stats-row">
              <div className="trend-stat-item">
                <div className="stat-icon">📊</div>
                <div className="stat-content">
                  <div className="stat-value">
                    ₹
                    {parseInt(
                      monthTrendData?.summary?.total_paid || 0
                    ).toLocaleString()}
                  </div>
                  <div className="stat-label">Year Total Paid</div>
                </div>
              </div>
              <div className="trend-stat-item">
                <div className="stat-icon">📈</div>
                <div className="stat-content">
                  <div className="stat-value">
                    ₹
                    {parseInt(
                      monthTrendData?.summary?.total_requested || 0
                    ).toLocaleString()}
                  </div>
                  <div className="stat-label">Year Total Requested</div>
                </div>
              </div>
              <div className="trend-stat-item">
                <div className="stat-icon">💰</div>
                <div className="stat-content">
                  <div className="stat-value">
                    {monthTrendData?.summary?.total_paid &&
                    monthTrendData?.summary?.total_requested
                      ? (
                          (monthTrendData.summary.total_paid /
                            monthTrendData.summary.total_requested) *
                          100
                        ).toFixed(1)
                      : 0}
                    %
                  </div>
                  <div className="stat-label">Payment Efficiency</div>
                </div>
              </div>
            </div> */}

            <div className="month-trend-cards">
              {monthTrendData?.data
                ?.slice(0, showAllMonths ? monthTrendData.data.length : 5)
                .map((month, index) => (
                  <div key={index} className="enterprise-month-card">
                    <div className="month-card-header">
                      <div className="month-info">
                        <div className="month-name">
                          {month.month_name} {monthTrendData?.year}
                        </div>
                        <div className="month-metrics">
                          <span className="metric-item">
                            <span className="metric-icon">✅</span>
                            {month.paid_count} paid
                          </span>
                          <span className="metric-item">
                            <span className="metric-icon">📋</span>
                            {month.requested_count} requested
                          </span>
                        </div>
                      </div>
                      <div className="month-efficiency">
                        <div className="efficiency-score">
                          {month.paid_count && month.requested_count
                            ? Math.round(
                                (month.paid_count / month.requested_count) * 100
                              )
                            : 0}
                          %
                        </div>
                        <div className="efficiency-label">Completion</div>
                      </div>
                    </div>

                    {/* Sparkline Chart */}
                    <div className="sparkline-container">
                      <div className="sparkline-header">
                        <span>Daily Activity</span>
                        <span className="sparkline-total">
                          ₹{parseInt(month.paid_amount || 0).toLocaleString()}
                        </span>
                      </div>
                      <div className="sparkline-chart">
                        {month.sparkline?.map((day, dayIndex) => {
                          const maxAmount = Math.max(
                            ...month.sparkline.map((d) => d.amount)
                          );
                          const height =
                            maxAmount > 0 ? (day.amount / maxAmount) * 40 : 0;
                          return (
                            <div
                              key={dayIndex}
                              className="sparkline-bar"
                              style={{ height: `${height}px` }}
                              title={`${day.day}: ₹${day.amount}`}
                            />
                          );
                        })}
                      </div>
                    </div>

                    {/* Amount Comparison */}
                    <div className="amount-comparison">
                      <div className="amount-row paid">
                        <div className="amount-info">
                          <span className="amount-label">
                            <span className="amount-dot paid"></span>
                            Paid Amount
                          </span>
                          <span className="amount-value">
                            ₹{parseInt(month.paid_amount || 0).toLocaleString()}
                          </span>
                        </div>
                        {month.paid_change_percentage !== undefined && (
                          <div
                            className={`change-badge ${
                              month.paid_change_percentage >= 0
                                ? "positive"
                                : "negative"
                            }`}
                            title={`${Math.abs(
                              month.paid_change_percentage
                            )}% ${
                              month.paid_change_percentage >= 0
                                ? "increase"
                                : "decrease"
                            } in paid amount compared to previous month`}
                          >
                            {month.paid_change_percentage >= 0 ? "↗" : "↘"}{" "}
                            {Math.abs(month.paid_change_percentage)}%
                          </div>
                        )}
                      </div>

                      <div className="amount-row requested">
                        <div className="amount-info">
                          <span className="amount-label">
                            <span className="amount-dot requested"></span>
                            Requested Amount
                          </span>
                          <span className="amount-value">
                            ₹
                            {parseInt(
                              month.requested_amount || 0
                            ).toLocaleString()}
                          </span>
                        </div>
                        {month.requested_change_percentage !== undefined && (
                          <div
                            className={`change-badge ${
                              month.requested_change_percentage >= 0
                                ? "positive"
                                : "negative"
                            }`}
                            title={`${Math.abs(
                              month.requested_change_percentage
                            )}% ${
                              month.requested_change_percentage >= 0
                                ? "increase"
                                : "decrease"
                            } in requested amount compared to previous month`}
                          >
                            {month.requested_change_percentage >= 0 ? "↗" : "↘"}{" "}
                            {Math.abs(month.requested_change_percentage)}%
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Progress Bar */}
                    <div className="progress-section">
                      <div className="progress-header">
                        <span>Payment Progress</span>
                        <span>
                          {month.paid_amount && month.requested_amount
                            ? Math.round(
                                (month.paid_amount / month.requested_amount) *
                                  100
                              )
                            : 0}
                          %
                        </span>
                      </div>
                      <div className="progress-bar">
                        <div
                          className="progress-fill"
                          style={{
                            width: `${
                              month.paid_amount && month.requested_amount
                                ? Math.min(
                                    (month.paid_amount /
                                      month.requested_amount) *
                                      100,
                                    100
                                  )
                                : 0
                            }%`,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                ))}
            </div>

            {/* View All Button */}
            {monthTrendData?.data?.length > 5 && (
              <div className="view-all-container">
                <button
                  className="view-all-btn"
                  onClick={() => setShowAllMonths(!showAllMonths)}
                >
                  {showAllMonths
                    ? "Show Less"
                    : `View All (${monthTrendData.data.length} months)`}
                </button>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Analytics Tables Grid - 2x2 Layout */}
      <div className="analytics-grid">
        {/* Top Paid People */}
        <div className="analytics-card">
          <div className="card-header">
            <h3 className="card-title">Top Paid People</h3>
            {/* <button className="view-all-btn">View All</button> */}
          </div>
          {topPaidLoading ? (
            <div className="loading-container">Loading...</div>
          ) : (
            <PaymentLinkTable
              tableData={topPaidData?.data || []}
              tableColumns={topPaidColumns}
              tablePagination={topPaidData?.pagination || []}
              isPage={isPage.topPaid}
              setIsPage={(value) =>
                setIsPage((prev) => ({ ...prev, topPaid: value }))
              }
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
            />
          )}
        </div>

        {/* Top Gyms Spend */}
        <div className="analytics-card">
          <div className="card-header">
            <h3 className="card-title">Top Gyms Spend</h3>
            {/* <button className="view-all-btn">View All</button> */}
          </div>
          {topGymsLoading ? (
            <div className="loading-container">Loading...</div>
          ) : (
            <PaymentLinkTable
              tableData={topGymsData?.data || []}
              tableColumns={topGymsColumns}
              tablePagination={topGymsData?.pagination || []}
              isPage={isPage.topGyms}
              setIsPage={(value) =>
                setIsPage((prev) => ({ ...prev, topGyms: value }))
              }
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
            />
          )}
        </div>

        {/* Pending FD Vendor Payments */}
        <div className="analytics-card">
          <div className="card-header">
            <h3 className="card-title">Pending FD Vendor Payments</h3>
            {/* <button className="view-all-btn">Remind All</button> */}
          </div>
          {pendingFdVendorLoading ? (
            <div className="loading-container">Loading...</div>
          ) : (
            <div>
              {/* Summary Stats */}
              <div className="pending-fd-summary">
                <div className="summary-item">
                  <div className="summary-value">
                    {pendingFdVendorData?.summary?.total_pending_requests || 0}
                  </div>
                  <div className="summary-label">Total Pending</div>
                </div>
                <div className="summary-item">
                  <div className="summary-value">
                    ₹
                    {parseInt(
                      pendingFdVendorData?.summary
                        ?.average_pending_per_requester || 0
                    ).toLocaleString()}
                  </div>
                  <div className="summary-label">Avg Per Requester</div>
                </div>
              </div>

              <PaymentLinkTable
                tableData={pendingFdVendorData?.data || []}
                tableColumns={pendingFdVendorColumns}
                tablePagination={pendingFdVendorData?.pagination || []}
                isPage={isPage.pendingFdVendor}
                setIsPage={(value) =>
                  setIsPage((prev) => ({ ...prev, pendingFdVendor: value }))
                }
                pageLimit={pageLimit}
                setPageLimit={setPageLimit}
              />
            </div>
          )}
        </div>

        {/* Category Spending Section */}
        <div className="analytics-card">
          <div className="card-header">
            <h3 className="card-title">Category Wise Spending</h3>
            {/* <button className="view-all-btn">Export Report</button> */}
          </div>
          {categorySpendLoading ? (
            <div className="loading-container">Loading category data...</div>
          ) : (
            <div>
              {categorySpendData?.data?.map((category, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "12px 0",
                    borderBottom:
                      index < categorySpendData.data.length - 1
                        ? "1px solid #e9ecef"
                        : "none",
                  }}
                >
                  <div>
                    <div style={{ fontWeight: "600", color: "#2c3e50" }}>
                      {category.category_name}
                    </div>
                    <div style={{ fontSize: "12px", color: "#6c757d" }}>
                      {category.total_expenses} expenses • {category.total_gyms}{" "}
                      gyms
                    </div>
                  </div>
                  <div style={{ textAlign: "right" }}>
                    <div
                      style={{
                        fontWeight: "600",
                        color: "#28a745",
                        fontSize: "16px",
                      }}
                    >
                      ₹{parseInt(category.total_spend || 0).toLocaleString()}
                    </div>
                    <div style={{ fontSize: "12px", color: "#6c757d" }}>
                      {category.percentage}% of total
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ExpenseAnalyticsLanding;
